export const translations = {
  en: {
    // HomePage
    settings: 'Settings',
    play: 'Play',
    shop: 'Shop',

    // MapView
    addStage: '+ Add Stage',
    noStagesYet: 'No Stages Yet',
    noStagesAdmin: 'Click "+ Add" to create one!',
    noStagesUser: 'Ask admin to add stages!',
    easy: 'EASY',
    hard: 'HARD',
    stages: 'Stages',
    switchToHard: 'Switch to Hard',
    switchToEasy: 'Switch to Easy',
    delete: 'Delete',

    // GameView
    back: 'Back',
    time: 'Time',
    moves: 'Moves',
    best: 'Best',
    hint: 'Hint',
    puzzleComplete: 'Puzzle Complete!',
    timeRemaining: 'Time Remaining',
    newPersonalBest: 'New Personal Best!',
    continue: 'Continue',
    timesUp: "Time's Up!",
    timesUpMessage: "Don't worry, let's try again!",
    restartPuzzle: 'Restart Puzzle',
    backToMap: 'Back to Map',
    specialTools: 'New tools coming soon',

    // Tutorial
    howToPlay: 'How to Play',
    rotateSwap: 'Rotate & Swap',
    rotateSwapDesc: 'Click to rotate pieces 90° or drag and drop to swap positions',
    completeBeforeTime: 'Complete Before Time & Moves Run Out',
    completeBeforeTimeDesc: 'Match all pieces before time runs out (Easy: 20s & 15 moves | Hard: 50s & 30 moves)',
    useHints: 'Use Hints',
    useHintsDesc: 'Click the hint button to see the complete image for 3 seconds',
    letsPlay: "Let's Play! 🚀",

    // Settings
    settingsTitle: 'Settings',
    adminMode: 'Admin Mode',
    adminModeDesc: 'Enable admin controls',
    soundEffects: 'Sound Effects',
    soundEffectsDesc: 'Play sounds',
    language: 'Language',
    languageDesc: 'Select language',
    english: 'English',
    spanish: 'Español',
    resetProgress: 'Reset Progress',
    resetProgressDesc: 'Clear all game data',
    resetProgressBtn: 'Reset All Progress',
    confirmReset: 'Are you sure you want to reset all progress? This cannot be undone.',
    progressReset: 'Progress has been reset!',
    version: 'Version',
    close: 'Close',

    // Upload Modal
    uploadStage: 'Upload New Stage',
    stageName: 'Stage Name',
    uploadImage: 'Upload Image',
    chooseFile: 'Choose File',
    mode: 'Mode',
    difficulty: 'Difficulty',
    applyToBoth: 'Apply to Both Modes',
    cancel: 'Cancel',
    save: 'Save'
  },
  es: {
    // HomePage
    settings: 'Ajustes',
    play: 'Jugar',
    shop: 'Tienda',

    // MapView
    addStage: '+ Añadir Nivel',
    noStagesYet: 'Aún No Hay Niveles',
    noStagesAdmin: '¡Haz clic en "+ Añadir" para crear uno!',
    noStagesUser: '¡Pídele al administrador que añada niveles!',
    easy: 'FÁCIL',
    hard: 'DIFÍCIL',
    stages: 'Niveles',
    switchToHard: 'Cambiar a Difícil',
    switchToEasy: 'Cambiar a Fácil',
    delete: 'Eliminar',

    // GameView
    back: 'Atrás',
    time: 'Tiempo',
    moves: 'Movimientos',
    best: 'Mejor',
    hint: 'Pista',
    puzzleComplete: '¡Rompecabezas Completado!',
    timeRemaining: 'Tiempo Restante',
    newPersonalBest: '¡Nuevo Récord Personal!',
    continue: 'Continuar',
    timesUp: '¡Se Acabó el Tiempo!',
    timesUpMessage: '¡No te preocupes, intentémoslo de nuevo!',
    restartPuzzle: 'Reiniciar Rompecabezas',
    backToMap: 'Volver al Mapa',
    specialTools: 'Nuevas herramientas próximamente',

    // Tutorial
    howToPlay: 'Cómo Jugar',
    rotateSwap: 'Rotar e Intercambiar',
    rotateSwapDesc: 'Haz clic para rotar piezas 90° o arrastra y suelta para intercambiar posiciones',
    completeBeforeTime: 'Completa Antes de que se Acabe el Tiempo y los Movimientos',
    completeBeforeTimeDesc: 'Coloca todas las piezas antes de que termine el tiempo (Fácil: 20s y 15 movimientos | Difícil: 50s y 30 movimientos)',
    useHints: 'Usar Pistas',
    useHintsDesc: 'Haz clic en el botón de pista para ver la imagen completa durante 3 segundos',
    letsPlay: '¡Vamos a Jugar! 🚀',

    // Settings
    settingsTitle: 'Ajustes',
    adminMode: 'Modo Administrador',
    adminModeDesc: 'Habilitar controles de administrador',
    soundEffects: 'Efectos de Sonido',
    soundEffectsDesc: 'Reproducir sonidos',
    language: 'Idioma',
    languageDesc: 'Seleccionar idioma',
    english: 'English',
    spanish: 'Español',
    resetProgress: 'Restablecer Progreso',
    resetProgressDesc: 'Borrar todos los datos del juego',
    resetProgressBtn: 'Restablecer Todo el Progreso',
    confirmReset: '¿Estás seguro de que quieres restablecer todo el progreso? Esto no se puede deshacer.',
    progressReset: '¡El progreso ha sido restablecido!',
    version: 'Versión',
    close: 'Cerrar',

    // Upload Modal
    uploadStage: 'Subir Nuevo Nivel',
    stageName: 'Nombre del Nivel',
    uploadImage: 'Subir Imagen',
    chooseFile: 'Elegir Archivo',
    mode: 'Modo',
    difficulty: 'Dificultad',
    applyToBoth: 'Aplicar a Ambos Modos',
    cancel: 'Cancelar',
    save: 'Guardar'
  }
};
